import "../styles/section3.css";

function Section3() {
  return (
    <div className="section3Wrapper blog">
      <div className="container">
        <div className="blog-head text-center">
          <h2>Company  Overview</h2>
          <h6>At JR Global Consultancy Services, we specialize in providing end-to-end IT services to startups and enterprises. With a team of passionate developers, 
            designers, and strategists, we turn your digital vision into reality.</h6>
        </div>

        <div className="row">
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="/e1.jpg" alt="img1" />
                  <h5 className="textBottom">	Mission</h5>
              <div className="overlay bottom-overlay">
                <div className="p-text">
            To deliver innovative, efficient, and reliable IT solutions that drive growth and transformation.


                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="/e2.webp" alt="img2" />
                  <h5 className="textBottom">Vision</h5>
              <div className="overlay bottom-overlay">
                <div className="p-text">
            To become a globally trusted IT partner for businesses.
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="e3.jpg" alt="img3" />
    <h5 className="textBottom">DevOps</h5>             
     <div className="overlay bottom-overlay">
                <div className="p-text">
                Automate and streamline your development cycle with CI/CD pipelines, containerization, and monitoring.
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="e4.webp" alt="img4" />
                  <h5 className="textBottom">IT Consulting</h5>
              <div className="overlay bottom-overlay">
                <div className="p-text">
               Strategic technology consulting to align your IT roadmap with business goals.
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="e5.webp" alt="img5" />
                  <h5 className="textBottom">Cloud Solutions</h5>
              <div className="overlay bottom-overlay">
                <div className="p-text"> 
               Cloud migration, deployment, and management using AWS, Azure, or Google Cloud.

                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="item">
              <img src="e6.webp" alt="img6" />
                  <h5 className="textBottom">Action </h5>
              <div className="overlay bottom-overlay">
                <div className="p-text">
              We deliver scalable software, web, and cloud solutions tailored to your business goals.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section3;
